import type { LaneMinimumSchedule } from "../../hooks/react-query/backOffice/useLaneMinimumSchedules";

export const mockLaneMinimumSchedules: LaneMinimumSchedule[] = [
  {
    id: 1,
    name: "Standard Lane Minimums",
    description: "Blind Shipment Fee",
    status: "Active",
    laneMinimumCount: 10,
    createdBy: "Carlos Mendez",
    createdOn: "11/5/2025",
    modifiedBy: "Carlos Mendez",
    modifiedOn: "11/5/2025",
    isGlobal: false,
  },
  {
    id: 2,
    name: "Regular Lane Minimums",
    description: "Standard shipping lanes",
    status: "Active",
    laneMinimumCount: 12,
    createdBy: "Sarah Johnson",
    createdOn: "10/15/2025",
    modifiedBy: "Sarah Johnson",
    modifiedOn: "10/20/2025",
    isGlobal: false,
  },
  {
    id: 3,
    name: "Regular Lane Minimums",
    description: "Extended coverage lanes",
    status: "Active",
    laneMinimumCount: 24,
    createdBy: "Mike Chen",
    createdOn: "09/01/2025",
    modifiedBy: "Mike Chen",
    modifiedOn: "09/15/2025",
    isGlobal: false,
  },
];
